import Vue from 'vue';
import App from './App.vue';
import router from './router';
import PrimeVue from 'primevue/config/PrimeVue';
import AutoComplete from 'primevue/autocomplete';
import Accordion from 'primevue/accordion';
import AccordionTab from 'primevue/accordiontab';
import Button from 'primevue/button';
import Breadcrumb from 'primevue/breadcrumb';
import Calendar from 'primevue/calendar';
import Card from 'primevue/card';
import Carousel from 'primevue/carousel';
import Chart from 'primevue/chart';
import Checkbox from 'primevue/checkbox';
import Chips from 'primevue/chips';
import Column from 'primevue/column';
import ContextMenu from 'primevue/contextmenu';
import DataTable from 'primevue/datatable';
import DataView from 'primevue/dataview';
import DataViewLayoutOptions from 'primevue/dataviewlayoutoptions';
import Dialog from 'primevue/dialog';
import Dropdown from 'primevue/dropdown';
import Editor from 'primevue/editor';
import Badge from 'primevue/badge';
import ColorPicker from 'primevue/colorpicker';
// import Fieldset from 'primevue/fieldset';
import Avatar from 'primevue/avatar';
import FileUpload from 'primevue/fileupload';
import FullCalendar from 'primevue/fullcalendar';
import Inplace from 'primevue/inplace';
import InputSwitch from 'primevue/inputswitch';
import InputText from 'primevue/inputtext';
import InputMask from 'primevue/inputmask';
import InputNumber from 'primevue/inputnumber';
import Listbox from 'primevue/listbox';
import MegaMenu from 'primevue/megamenu';
import Menu from 'primevue/menu';
import Menubar from 'primevue/menubar';
import Message from 'primevue/message';
import MultiSelect from 'primevue/multiselect';
import OrderList from 'primevue/orderlist';
import OrganizationChart from 'primevue/organizationchart';
import OverlayPanel from 'primevue/overlaypanel';
import Paginator from 'primevue/paginator';
import Panel from 'primevue/panel';
import PanelMenu from 'primevue/panelmenu';
import Password from 'primevue/password';
import PickList from 'primevue/picklist';
import ProgressBar from 'primevue/progressbar';
import ProgressSpinner from 'primevue/progressspinner';
import Rating from 'primevue/rating';
import RadioButton from 'primevue/radiobutton';
import SelectButton from 'primevue/selectbutton';
import Slider from 'primevue/slider';
import Sidebar from 'primevue/sidebar';
import SplitButton from 'primevue/splitbutton';
import Steps from 'primevue/steps';
import TabMenu from 'primevue/tabmenu';
import TieredMenu from 'primevue/tieredmenu';
import Textarea from 'primevue/textarea';
import Toast from 'primevue/toast';
import ToastService from 'primevue/toastservice';
import Toolbar from 'primevue/toolbar';
import TabView from 'primevue/tabview';
import TabPanel from 'primevue/tabpanel';
import Tooltip from 'primevue/tooltip';
import ToggleButton from 'primevue/togglebutton';
import Tree from 'primevue/tree';
import TreeTable from 'primevue/treetable';
import TriStateCheckbox from 'primevue/tristatecheckbox';
import BlockUI from 'primevue/blockui';
import ConfirmationService from 'primevue/confirmationservice';
import ConfirmDialog from 'primevue/confirmdialog';
import Timeline from 'primevue/timeline';

import VueBarcode from 'vue-barcode';

//import VueGoogleAutocomplete from 'vue-google-autocomplete'
import JsonExcel from "./views/JsonExcel.vue";
import CKEditor from '@ckeditor/ckeditor5-vue2';
import vSelect from 'vue-select';

import 'primevue/resources/themes/nova/theme.css';
import 'primevue/resources/primevue.min.css';
import 'primeflex/primeflex.css';
import 'primeicons/primeicons.css';
import 'prismjs/themes/prism-coy.css';
import '@fullcalendar/core/main.min.css';
import '@fullcalendar/daygrid/main.min.css';
import '@fullcalendar/timegrid/main.min.css';
import './assets/layout/layout.scss';
import 'vue-select/dist/vue-select.css';
import "vue-select/src/scss/vue-select.scss"
// import { createProvider,onLogin} from './vue-apollo'//, onLogin, onLogout
import ColumnGroup from 'primevue/columngroup';
import Row from 'primevue/row';
import underscore from 'vue-underscore';
// import fire from '../public/firebase-messaging-sw';
import VModal from 'vue-js-modal';
import VueApexCharts from 'vue-apexcharts';
Vue.use(VueApexCharts)

Vue.component('apexchart', VueApexCharts)
Vue.use(VModal, { dynamic: true, injectModalsContainer: true, dialog: true })


Vue.use(PrimeVue, {ripple: true, locale: {
  dayNames: ["Chủ nhật", "Thứ 2", "Thứ 3", "Thứ 4", "Thứ 5", "Thứ 6", "Thứ 7"],
  dayNamesShort: ["CN", "T2", "T3", "T4", "T5", "T6", "T7"],
  dayNamesMin: ["CN", "T2", "T3", "T4", "T5", "T6", "T7"],
  monthNames: ["Tháng 1", "Tháng 2", "Tháng 3", "Tháng 4", "Tháng 5", "Tháng 6", "Tháng 7", "Tháng 8", "Tháng 9", "Tháng 10", "Tháng 11", "Tháng 12"],
  monthNamesShort: ["T1", "T2", "T3", "T4", "T5", "T6", "T7", "T8", "T9", "T10", "T11", "T12"],
  today: 'Hôm nay',
  clear: 'Xóa'
}});
Vue.use(ConfirmationService);

Vue.use(ToastService);
Vue.directive('tooltip', Tooltip);
Vue.use(require('vue-moment'));
Vue.use(underscore)

Vue.config.productionTip = false;

Vue.component('ConfirmDialog', ConfirmDialog);
Vue.component('Accordion', Accordion);
Vue.component('AccordionTab', AccordionTab);
Vue.component('AutoComplete', AutoComplete);
Vue.component('Avatar', Avatar);
Vue.component('Breadcrumb', Breadcrumb);
Vue.component('Button', Button);
Vue.component('BlockUI', BlockUI);
Vue.component('Calendar', Calendar);
Vue.component('Card', Card);
Vue.component('Carousel', Carousel);
Vue.component('Chart', Chart);
Vue.component('Checkbox', Checkbox);
Vue.component('Chips', Chips);
Vue.component('Column', Column);
Vue.component('ContextMenu', ContextMenu);
Vue.component('DataTable', DataTable);
Vue.component('DataView', DataView);
Vue.component('DataViewLayoutOptions', DataViewLayoutOptions);
Vue.component('Dialog', Dialog);
Vue.component('Dropdown', Dropdown);
Vue.component('Editor', Editor);
Vue.component('Badge', Badge);
Vue.component('ColorPicker', ColorPicker);
// Vue.component('Fieldset', Fieldset);
Vue.component('FileUpload', FileUpload);
Vue.component('FullCalendar', FullCalendar);
Vue.component('Inplace', Inplace);
Vue.component('InputSwitch', InputSwitch);
Vue.component('InputText', InputText);
Vue.component('InputMask', InputMask);
Vue.component('InputNumber', InputNumber);
Vue.component('Listbox', Listbox);
Vue.component('MegaMenu', MegaMenu);
Vue.component('Menu', Menu);
Vue.component('Menubar', Menubar);
Vue.component('Message', Message);
Vue.component('MultiSelect', MultiSelect);
Vue.component('OrderList', OrderList);
Vue.component('OrganizationChart', OrganizationChart);
Vue.component('OverlayPanel', OverlayPanel);
Vue.component('Paginator', Paginator);
Vue.component('Panel', Panel);
Vue.component('PanelMenu', PanelMenu);
Vue.component('Password', Password);
Vue.component('PickList', PickList);
Vue.component('ProgressBar', ProgressBar);
Vue.component('ProgressSpinner', ProgressSpinner);
Vue.component('RadioButton', RadioButton);
Vue.component('Rating', Rating);
Vue.component('SelectButton', SelectButton);
Vue.component('Slider', Slider);
Vue.component('Sidebar', Sidebar);
Vue.component('SplitButton', SplitButton);
Vue.component('Steps', Steps);
Vue.component('TabMenu', TabMenu);
Vue.component('TabView', TabView);
Vue.component('TabPanel', TabPanel);
Vue.component('Textarea', Textarea);
Vue.component('TieredMenu', TieredMenu);
Vue.component('Toast', Toast);
Vue.component('Toolbar', Toolbar);
Vue.component('ToggleButton', ToggleButton);
Vue.component('Tree', Tree);
Vue.component('TreeTable', TreeTable);
Vue.component('TriStateCheckbox', TriStateCheckbox);
Vue.component('Timeline', Timeline);
//Vue.component('vue-google-autocomplete', VueGoogleAutocomplete );
Vue.component("ExportExcel", JsonExcel);
Vue.component('barcode', VueBarcode)
Vue.use( CKEditor );
Vue.component('v-select', vSelect)
Vue.component('ColumnGroup', ColumnGroup);
Vue.component('Row', Row);
import { BootstrapVue, IconsPlugin } from 'bootstrap-vue'

// Import Bootstrap an BootstrapVue CSS files (order is important)
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'

// Make BootstrapVue available throughout your project
Vue.use(BootstrapVue)
// Optionally install the BootstrapVue icon components plugin
Vue.use(IconsPlugin)

//import * as firebase from 'firebase/app'
import store from './store'
import config from './config/index'
import configJson from '../config.json'
import commonFuction from './core/Common'
import constants from './core/Constants'
import CoreService from "./core/CoreService";
import CommonList from "./core/CommonList";
import AuthenticationApp from "./core/AuthenticationApp";
import ApiRepository from "./core/ApiRepository";
//import * as VueGoogleMaps from "vue2-google-maps";

var envConfig = (process.env.NODE_ENV == 'development' || process.env.NODE_ENV == 'production' || process.env.NODE_ENV == 'test') ? process.env.NODE_ENV:'development';
console.log("process.env.NODE_ENVprocess.env.NODE_ENV:",process.env.NODE_ENV);
console.log("envConfigenvConfigenvConfig:",envConfig);
/*
Vue.use(VueGoogleMaps, {
  load: config.googleMaps(),
  installComponents: true
});*/
/*
const firebaseConfig = configJson[envConfig].firebaseConfig;
// Initialize Firebase
firebase.initializeApp(firebaseConfig);
firebase.analytics();
firebase.auth().onAuthStateChanged(function (user) {
  // console.log(user)
  if (user) {
    store.commit('setUser', user.uid)
    store.commit('setIsLoggedIn', true)
  } else {
    // User is signed out.
    // ...
    // console.log('User logout')
    store.commit('setUser', null)
    store.commit('setIsLoggedIn', false)
    store.commit('setToken', null)
    onLogout(null)
  }
})

firebase.getCurrentUser = () => {
  return new Promise((resolve, reject) => {
    const unsubscribe = firebase.auth().onAuthStateChanged(user => {
      unsubscribe()
      resolve(user)
    }, reject)
  })
}*/
import firebaseMessaging from './firebase'
const initialModuleFromUrl = new URLSearchParams(window.location.search).get('module');
// console.log('[main.js] initial module from url:', initialModuleFromUrl);
if (initialModuleFromUrl) {
  store.commit('setModuleStore', initialModuleFromUrl);
  // console.log('[main.js] committed initial moduleStore:', store.getters.moduleStore);
}
AuthenticationApp.getStateLogin().then(async state_login => {
  if (commonFuction.isEmpty(state_login)){
    //onLogout(null);
    // var url_current = window.location.href;
    // if ((url_current.search("auth/login")) == -1){
    //   //Nếu trang hiện tại ko phải trang login thì logout ra trang login || còn đang ở trang login thì ko cần logout
    //   AuthenticationApp.clearDataLogout();
    // }
    return false;
  }
  var token = state_login.token
  var minus_time = moment().tz("UTC").subtract(60*10, 'seconds').format('YYYYMMDDHHmmss'); //-10phut //60*10
  var dateChangeToken = state_login.dateChangeToken;
  if (parseFloat(minus_time) < parseFloat(dateChangeToken)) {
    //Function này để check trường hợp đổi password thì logout tất cả các thiết bị || Nếu thời gian đăng nhập > (thời gian hiện tại -10 phút) thì check
    await AuthenticationApp.checkToken(token).then(async (res) => {
      if (res) {
        //token tồn tại
        console.log("ressssssss:", res);
        store.commit('setToken', token)
        store.commit('setType', res.type)
        store.commit('setUser', state_login.uid)
        store.commit('setIsLoggedIn', true)
        store.commit('setTokenRefesh', res.token_refesh)
        store.commit('setRole', res.role)
        store.commit('setDepartment', res?.list_department ?? state_login?.list_department)
        store.commit('setListCompany', res.list_id_company)
        store.commit('setCompany', res.company_id)
        store.commit('setFullname', res.fullname)
        store.commit('setRoleCompany', res.role_company);
        store.commit('setTypeCompany', res.type_company);
        store.commit('setCompanyType', res.company_type);
        if(firebaseMessaging){
          await firebaseMessaging.getToken({ vapidKey: config.fireBase().vapidKey }).then(async (currentToken) => {
            if (currentToken) {
                store.commit("setDeviceToken", currentToken);
            }
          });
        }
      }
    })
  }
  //console.log('token---->',token);
  //Set token cho page

  //onLogin(null, token)
  //Trường hợp đóng trình duyệt để lâu ngày mở lại thì refesh nếu > 10 phút
  AuthenticationApp.refeshToken();
  console.log("storestorestorestore", store?.getters);
})

//refesh token
setInterval(function(){
  if (store?.getters?.token){
    //Gọi API refeshtoken
    AuthenticationApp.refeshToken();
  }
},1000*60 ); //1 phút refesh 1 lần để kiểm tra

async function checkPermission (){
  const currentUser = await AuthenticationApp.getStateLogin();

  var listMenuSupp = [];
  
  if (currentUser) {
    var token = currentUser.token
    //console.log('token---->',token);
    store.commit('setToken', token)
    store.commit('setType', currentUser.type)
    store.commit('setUser', currentUser.uid)
    store.commit('setCompany', currentUser.company_id)
    store.commit('setRoleCompany', currentUser.role_company);
    store.commit('setTypeCompany', currentUser.type_company);
    store.commit('setCompanyType', currentUser.company_type);
    if(token){
      const headers = {
        "Authorization": "Bearer "+token,
      };
      listMenuSupp = await ApiRepository.post(constants.getConstans().API.USER_CONTROLLER, {}, {headers}).then(function (response) {
        var data = response?.data?.data?.listMenuSupp ?? [];
        // console.log("data", data);
        var listMenu = [];
        data.map(m => {
          if (m?.items) {
            m.items.map(n => {
              listMenu.push(n.to);
            })
          } else {
            listMenu.push(m.to);
          }
        })
        return listMenu
      })
    }
    // onLogin(null, token)
  }
  
  return {listMenuSupp, currentUser};
}

const permissionPromise = checkPermission();

permissionPromise.then(({listMenuSupp, currentUser}) => {
  if (!currentUser && window.location.pathname.includes("/admin")) {
    // router.push({path:'/auth/login'});
    AuthenticationApp.redirectToLogin();
    return;
  }
  router.beforeEach((to, from, next) => {
    const requiresAuth = to.matched.some(x => x.meta.requiresAuth)
    if (to.query.module) {
      store.commit('setModuleStore', to.query.module)
    }
    // console.log("requiresAuthrequiresAuth", requiresAuth);
    if (requiresAuth && !currentUser) {
      window.location.href = AuthenticationApp.buildLoginUrl(to.fullPath || to.path);
      return;
    } else {
      // console.log("listMenuSupp", listMenuSupp);
      var pathArr = to.path.split('/');
      // console.log("from.path", from.path);
      // console.log("pathArr", pathArr);
      if (pathArr.length > 4) {
        pathArr.pop();
      }
      var new_path = pathArr.join("/");
      var checkPath = listMenuSupp.filter(f => f == new_path);
      // console.log("checkPath", checkPath);
      // console.log("to.path",to.path)
      if (from.path == '/redirect' && to.path=='/auth/login') {
        window.location.reload();
        // next()
        // return
      } else {
        if (!['/admin/403', '/auth/login', '/auth/confirm-email', '/403', '/404', '/redirect', '/admin', '/', '/home/modules'].includes(to.path) && checkPath.length < 1 && from.path != "/admin") {
          next('/admin/403');
        } else {
          if (to.path != from.path) {
            next();
          }
        }
      }
    }
  })
})

import CoolLightBox from 'vue-cool-lightbox'
import 'vue-cool-lightbox/dist/vue-cool-lightbox.min.css'
Vue.use(CoolLightBox)

import i18n from './i18n'
import {helpers} from './helpers'
import moment from "moment-timezone";

Vue.prototype.$commonFuction = commonFuction;
Vue.prototype.$constants = constants.getConstans();
Vue.prototype.$CoreService = CoreService;
Vue.prototype.$CommonList = CommonList;
Vue.prototype.$AuthenticationApp = AuthenticationApp;
Vue.prototype.$ConfigEvn = configJson[envConfig];
Vue.prototype.$messaging = firebaseMessaging

new Vue({
  router,
  // apolloProvider: createProvider(),
  store,
  i18n,
  render: h => h(App)
}).$mount('#app');
Vue.prototype.$helpers = helpers
